import { render } from "./Switcher.vue?vue&type=template&id=19c00c2a&scoped=true"
import script from "./Switcher.vue?vue&type=script&lang=js"
export * from "./Switcher.vue?vue&type=script&lang=js"

import "./Switcher.vue?vue&type=style&index=0&id=19c00c2a&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c00c2a"]])

export default __exports__